import produce from 'immer'
import moment from 'moment'

import * as constants from './constants'
import api from '../../api'

const URL_BASE = 'rules'

export const getRecords = ( action=null ) => {
  const request = '/'+URL_BASE
  if ( action )
    return api.makeRequest({
      url: request,
    }, action );
  return api.makeBasicRequest( request );
}

export const getRecord = ( recordId, action=null ) => {
  const request = '/'+URL_BASE+'/'+recordId;
  if ( action )
    return api.makeRequest( request, action );
  return api.makeBasicRequest( request );
}

export const updateRecord = record => {
  console.log( "Updating rule", record );
  if ( record.RuleId )
    return api.makeRequest({
      method: 'put',
      url: '/'+URL_BASE+'/'+record.RuleId,
      data: {
        record
      }},
      constants.RECORD_UPDATE
    )
  return api.makeRequest({
    method: 'post',
    url: '/'+URL_BASE,
    data: {
      record
    }},
    constants.RECORD_UPDATE
  )
}

export const deleteRecord = record => {
  console.log( "Deleting record", record );
  return api.makeRequest({
      method: 'delete',
      url: '/'+URL_BASE+'/'+record.RuleId
    },
    constants.RECORD_DELETE,
  );
}
